<template>
  <el-dialog
    :visible.sync="visible"
    title="费用设置"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :append-to-body="true"
  >
    <el-form
      :model="dataForm"
      :rules="dataRule"
      ref="dataForm"
      label-width="120px"
    >
      <el-row :gutter="16">
        <el-col :span="12">
          <el-form-item label="外销合同：" prop="orderCode">
            <order-drop v-model="dataForm.orderCode" size="medium"></order-drop>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="费用名称：" prop="name">
            <el-input
                v-model="dataForm.name"
                placeholder="请输入费用名称"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="数量：" prop="count">
            <el-input v-model="dataForm.count" placeholder="数量"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="金额：" prop="amount">
            <el-input v-model="dataForm.amount" placeholder="金额"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="费用时间：" prop="operateTime">
            <el-date-picker
                v-model="dataForm.operateTime"
                type="date"
                value-format="yyyy-MM-dd"
                style="width: 100%"
                placeholder="选择费用时间"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="开票方：" prop="sellerReceiptId">
            <company-account v-model="dataForm.sellerReceiptId" size="medium"></company-account>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="发票号：" prop="receiptCode">
            <el-input v-model="dataForm.receiptCode" placeholder="请输入发票号"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="部门/车间：" prop="dept">
            <el-input v-model="dataForm.dept" placeholder="请输入部门/车间"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="备注：" prop="remark">
        <el-input v-model="dataForm.remark" type="textarea" :rows="6" placeholder="请输入备注"></el-input>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="cancel">{{ $t("cancel") }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{
        $t("confirm")
      }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import CommonDrop from "@/components/CommonDrop";
import debounce from "lodash/debounce";
import { moneyValidator } from "@/utils/validate";
import CompanyAccount from '@/views/modules/trade/common/CompanyAccount'
export default {
  components: { CommonDrop,CompanyAccount },
  props: {
    agreementId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      id: "",
      visible: false,
      dataForm: {},
    };
  },
  watch: {
    agreementId: {
      handler: function(newVal) {
        this.$set(this.dataForm, "agreementId", newVal);
      },
      immediate: true,
    },
  },
  computed: {
    dataRule() {
      return {
        name: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "change",
          },
        ],
        amount: [
          { required: true, message: "请填写金额", trigger: "change" },
          { validator: moneyValidator, trigger: "change" },
        ],
        operateTime: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "change",
          },
        ]
      };
    },
  },
  methods: {
    reset() {
      this.dataForm = {
        id: "",
        name: "",
        categoryName: "",
        amount: "",
        operateTime: "",
        currency: "人民币",
        agreementId: "",
        orderCode:'',
        sellerReceiptId:'',
        receiptCode:'',
        remark:'',
        count:1,
      };
      if (this.$refs["dataForm"]) {
        this.$refs["dataForm"].resetFields();
      }
    },
    init() {
      this.visible = true;
      this.$nextTick(() => {
        this.reset();
        if (this.id) {
          this.getInfo();
        }
      });
    },
    // 获取信息
    getInfo() {
      this.$http
        .get(`/trade/cost/${this.id}`)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg);
          }
          this.dataForm = {
            ...this.dataForm,
            ...res.data,
          };
        })
        .catch(() => {});
    },

    // 表单提交
    dataFormSubmitHandle: debounce(
      function() {
        this.$refs["dataForm"].validate((valid) => {
          if (!valid) {
            return false;
          }
          let postForm = {
            ...this.dataForm,
            agreementId:this.agreementId
          };
          this.$http[!postForm.id ? "post" : "put"]("/trade/cost/", postForm)
            .then(({ data: res }) => {
              if (res.code !== 0) {
                return this.$message.error(res.msg);
              }
              this.$message({
                message: this.$t("prompt.success"),
                type: "success",
                duration: 500,
                onClose: () => {
                  this.cancel();
                  this.$emit("refreshDataList");
                },
              });
            })
            .catch(() => {});
        });
      },
      1000,
      { leading: true, trailing: false }
    ),
    cancel() {
      this.visible = false;
    },
  },
};
</script>
